/**
 * Copyright (c) 2019 7thCode. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {ContactComponent} from "./contact.component";
import {FlexModule} from "@angular/flex-layout";
import {ContactDialogComponent} from "./contact-dialog/contact-dialog.component";
import {MatDialogModule} from "@angular/material/dialog";
import {MatCardModule} from "@angular/material/card";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";
import {MatListModule} from "@angular/material/list";
import {MatPaginatorModule} from "@angular/material/paginator";
import {BasePipeModule} from "../../platform/base/pipes/base-pipe.module";
import {ContactDialogDirective} from "./contact-dialog/contact-dialog.directive";
import {ContactInfoDialogComponent} from "./contact-info-dialog/contact-info-dialog.component";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
	declarations: [
		ContactComponent,
		ContactDialogComponent,
		ContactDialogDirective,
		ContactInfoDialogComponent
	],
	exports: [
		ContactDialogDirective
	],
	imports: [
		CommonModule,
		FlexModule,
		MatDialogModule,
		MatCardModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		FormsModule,
		MatIconModule,
		MatListModule,
		BasePipeModule,
		MatPaginatorModule,
		TranslateModule
	],
	bootstrap: [
		ContactDialogComponent,
		ContactInfoDialogComponent
	],
})
export class ContactModule {
}
